var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsapp1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "qbqfophuia",
    x1: "15.337%",
    x2: "87.686%",
    y1: "20.953%",
    y2: "77.588%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5AD068"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#45B629"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "2liq31g3yf",
    x1: "50%",
    x2: "50%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hv3mhfawsb",
    d: "M.183 14.571c0 2.561.668 5.06 1.94 7.264L.061 29.364l7.705-2.02c2.123 1.157 4.513 1.767 6.945 1.768h.006c8.01 0 14.531-6.518 14.534-14.529.002-3.883-1.509-7.533-4.253-10.28-2.744-2.746-6.393-4.259-10.28-4.26C6.705.043.185 6.56.182 14.57zm4.588 6.885l-.287-.457c-1.21-1.923-1.848-4.145-1.847-6.427C2.64 7.914 8.059 2.497 14.722 2.497c3.227.001 6.26 1.259 8.54 3.541 2.281 2.283 3.536 5.317 3.535 8.544-.003 6.659-5.421 12.076-12.08 12.076h-.004c-2.168 0-4.294-.583-6.149-1.683l-.441-.262-4.572 1.2 1.22-4.457z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "77wa2i940e",
    d: "M.183 14.571c0 2.561.668 5.06 1.94 7.264L.061 29.364l7.705-2.02c2.123 1.157 4.513 1.767 6.945 1.768h.006c8.01 0 14.531-6.518 14.534-14.529.002-3.883-1.509-7.533-4.253-10.28-2.744-2.746-6.393-4.259-10.28-4.26C6.705.043.185 6.56.182 14.57zm4.588 6.885l-.287-.457c-1.21-1.923-1.848-4.145-1.847-6.427C2.64 7.914 8.059 2.497 14.722 2.497c3.227.001 6.26 1.259 8.54 3.541 2.281 2.283 3.536 5.317 3.535 8.544-.003 6.659-5.421 12.076-12.08 12.076h-.004c-2.168 0-4.294-.583-6.149-1.683l-.441-.262-4.572 1.2 1.22-4.457z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "so9r0mv9hd",
    width: "148%",
    height: "147.7%",
    x: "-24%",
    y: "-17.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.26 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z",
    transform: "translate(-164 -380) translate(164 380)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M.061 29.364l2.062-7.529C.851 19.632.183 17.132.183 14.571.186 6.561 6.706.043 14.717.043c3.888.001 7.537 1.515 10.281 4.26 2.744 2.747 4.255 6.398 4.253 10.28-.003 8.01-6.523 14.53-14.534 14.53h-.006c-2.432-.002-4.822-.612-6.945-1.77L.06 29.365z",
    transform: "translate(-164 -380) translate(164 380) translate(1 2)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#qbqfophuia)",
    d: "M.684 14.576c0 2.472.645 4.885 1.873 7.012l-1.99 7.269 7.438-1.95c2.049 1.116 4.356 1.706 6.704 1.706h.007c7.732 0 14.027-6.292 14.03-14.026.001-3.748-1.457-7.272-4.106-9.923S18.468.552 14.715.55C6.98.55.687 6.842.684 14.576",
    transform: "translate(-164 -380) translate(164 380) translate(1 2)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-164 -380) translate(164 380) translate(1 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "524p7flngc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hv3mhfawsb"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#524p7flngc)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#so9r0mv9hd)",
    xlinkHref: "#77wa2i940e"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#2liq31g3yf)",
    xlinkHref: "#77wa2i940e"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M11.085 8.498c-.272-.605-.559-.617-.817-.628-.212-.01-.454-.008-.696-.008-.242 0-.636.09-.969.454-.333.363-1.27 1.242-1.27 3.028 0 1.787 1.3 3.514 1.482 3.756.182.243 2.512 4.026 6.204 5.482 3.067 1.21 3.692.969 4.357.908.666-.06 2.149-.878 2.452-1.726.302-.848.302-1.575.211-1.726-.09-.152-.332-.243-.696-.424-.363-.182-2.148-1.06-2.481-1.181-.333-.122-.575-.182-.817.182-.242.363-.938 1.18-1.15 1.423-.212.242-.424.272-.787.091-.363-.182-1.533-.565-2.92-1.802-1.08-.963-1.809-2.152-2.02-2.515-.212-.363-.023-.56.159-.741.163-.163.363-.424.545-.636.181-.212.242-.364.363-.606.12-.242.06-.454-.03-.636-.091-.181-.797-1.977-1.12-2.695",
    transform: "translate(-164 -380) translate(164 380) translate(1 2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp1);
export default __webpack_public_path__ + "static/media/whatsapp1.c72b9bc4ad1d460508885f509a578dc2.svg";
export { ForwardRef as ReactComponent };